import { faMagnifyingGlass } from "@fortawesome/pro-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  Form,
  Select,
  Button,
  Table,
  Switch,
  Space,
  Input,
  Radio,
  Modal,
  notification,
  Typography,
} from "antd";
import { useState } from "react";
import {
  useAdminCaregiver,
  useCaregiverAdminUpdate,
  useCaregiverApplication,
  useCreateBackgroundCheckr,
} from "../../api/Admin";
import Loading from "../../components/Loading";
import SubmitButton from "../../components/SubmitButton";
import UserDisplay from "../../components/UserDisplay";
import ContentLayout from "../../layout/ContentLayout";

const { Link } = Typography;

const CaregiverReview = () => {
  const [search, setSearch] = useState({ limit: 100 });

  const { data, isLoading } = useAdminCaregiver(search);

  const nextPage = (token) => {
    setSearch({ ...search, ...{ next: token } });
  };

  return (
    <ContentLayout fullpage>
      <Filters onSearch={setSearch} />
      {isLoading ? (
        <Loading />
      ) : (
        <>
          <CaregiverTable caregivers={data?.Users} />
          {data?.NextPage && (
            <Button onClick={() => nextPage(data?.NextPage)}>Load More</Button>
          )}
        </>
      )}
    </ContentLayout>
  );
};

const CaregiverTable = ({ caregivers }) => {
  const columns = [
    {
      title: "User",
      dataIndex: "UserId",
      key: "UserId",
      render: (_, user) => (
        <>
          <UserDisplay user={user} size={25} />
          <Typography.Paragraph copyable>{user?.Email}</Typography.Paragraph>
          <Typography.Text copyable>{user?.UserId}</Typography.Text>
        </>
      ),
    },
    {
      title: "Actions",
      dataIndex: "idk",
      key: "actions",
      render: (_, user) => <CaregiverActions caregiver={user} />,
    },
  ];
  return <Table columns={columns} dataSource={caregivers} />;
};

const CaregiverActions = ({ caregiver }) => {
  const [approved, setApproved] = useState(
    caregiver?.CaregiverStatus === "APPROVED"
  );
  const [screened, setScreened] = useState(caregiver?.Screened);
  const [showBackgroundCheck, setShowBackgroundCheck] = useState(false);
  const [needsBackgroundCheck, setNeedsBackgroundCheck] = useState(
    !caregiver?.BackgroundCheckStatus
  );

  const caregiverUpdate = useCaregiverAdminUpdate(caregiver?.UserId);

  const toggleEnabled = async (value) => {
    caregiverUpdate
      .mutateAsync({
        CaregiverStatus: value === true ? "APPROVED" : "DISABLED",
      })
      .then((r) => {
        setApproved(value);
      });
  };

  const toggleScreened = async (value) => {
    caregiverUpdate
      .mutateAsync({
        Screened: value,
      })
      .then((r) => {
        setScreened(value);
      });
  };

  return (
    <Space>
      <Space>
        <Switch
          size="small"
          checked={approved}
          onChange={(e) => toggleEnabled(e)}
        />{" "}
        Approved
      </Space>
      {!screened && (
        <Button onClick={() => toggleScreened(true)} size="small">
          Screen Complete
        </Button>
      )}
      {needsBackgroundCheck && (
        <>
          <Button size="small" onClick={() => setShowBackgroundCheck(true)}>
            Background Check
          </Button>
          {showBackgroundCheck && (
            <BackgroundCheckForm
              caregiver={caregiver}
              close={() => setShowBackgroundCheck(false)}
            />
          )}
        </>
      )}
    </Space>
  );
};

const BackgroundCheckForm = ({ caregiver, close }) => {
  const { data } = useCaregiverApplication(caregiver.UserId);
  const backgroundCheck = useCreateBackgroundCheckr();
  const create = async () => {
    backgroundCheck
      .mutateAsync({
        Email: caregiver.Email,
        UserId: caregiver.UserId,
        State: data?.application?.State,
      })
      .then(() => {
        close();
        notification.success("Background check initiated");
      });
  };
  return (
    <Modal
      open
      title={`Request background check for ${caregiver?.FirstName} ${caregiver?.LastName}`}
      footer={[
        <Button onClick={() => close()}>Cancel</Button>,
        <Button type="primary" onClick={() => create()}>
          Request
        </Button>,
      ]}
    >
      {data?.application?.State}
    </Modal>
  );
};

const Filters = ({ onSearch }) => {
  const [form] = Form.useForm();
  const [inputType, setInputType] = useState("email");
  const submit = () => {
    let v = form.getFieldsValue();
    onSearch && onSearch(v);
  };

  return (
    <>
      <Form
        form={form}
        initialValues={{ status: "", email: "" }}
        onFinish={submit}
        style={{ marginBottom: "20px" }}
        layout="inline"
      >
        <Form.Item name="status">
          <Radio.Group
            options={[
              { label: "All", value: "" },
              {
                label: "Approved",
                value: "APPROVED",
              },
              {
                label: "Applied",
                value: "APPLIED",
              },
              { label: "Disabled", value: "DISABLED" },
            ]}
            buttonStyle="solid"
            optionType="button"
            onChange={() => {
              form.submit();
            }}
          />
        </Form.Item>
        <Form.Item name={inputType}>
          <Input
            allowClear
            addonAfter={
              <Select
                onChange={(v) => setInputType(v)}
                value={inputType}
                options={[
                  { label: "Email", value: "email" },
                  { label: "User ID", value: "userid" },
                ]}
              />
            }
          />
        </Form.Item>
        <Form.Item>
          <SubmitButton type="primary">
            <FontAwesomeIcon icon={faMagnifyingGlass} />
          </SubmitButton>
        </Form.Item>
      </Form>
    </>
  );
};

export default CaregiverReview;
